import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { getGroupId } from 'store/session/selectors';

import {
  fetchTermsAndConditions,
  types,
  updateTermsAndConditions,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_TERMS_AND_CONDITIONS_REQUEST,
    watchUpdateTermsAndConditions,
  );
}

function* watchFetchTermsAndConditions() {
  try {
    const groupId = yield select(getGroupId);
    const { value } = yield call(API.supplier.getTermsAndConditions, groupId);
    yield put(fetchTermsAndConditions.success({ termsAndConditions: value }));
  } catch (error) {
    console.error('FAILED TO FETCH TERMS AND CONDITIONS', error);
    yield put(fetchTermsAndConditions.error({ error }));
  }
}

function* watchUpdateTermsAndConditions(action) {
  try {
    const groupId = yield select(getGroupId);
    const { termsAndConditions } = action.payload;
    const { value } = yield call(
      API.supplier.updateSupplierTermsAndConditions,
      groupId,
      {
        value: termsAndConditions,
      },
    );
    if (value) {
      yield put(
        updateTermsAndConditions.success({ termsAndConditions: value }),
      );
    }
  } catch (error) {
    yield put(updateTermsAndConditions.error(error));
  }
}

export function* initSaga() {
  yield all([watchFetchTermsAndConditions()]);
}
